export default __webpack_public_path__ + "static/media/deadvines.e9e74122.png";